/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DiffData } from "./DiffData";
import { Resolve } from "../../dataClips/types/Resolve";
import { RecordBase } from "./RecordBase";
export const DiffRecord = core.serialization
    .object({
    values: DiffData,
    resolves: core.serialization.list(Resolve).optional(),
})
    .extend(RecordBase);
